import { useState, useEffect } from "react";
import ApiClient from "../../../ApiClient";

const apiClient = ApiClient();

const useResolveTransactionReference = (sessionId) => {
    const [merchantTransactionReference, setMerchantTransactionReference] = useState(null);
    const [isResolving, setIsResolving] = useState(true);
    const { getMerchantTransactionReference } = apiClient;

    useEffect(() => {
        if (!sessionId) {
            setIsResolving(false);
            return;
        }

        const fetch = async () => {
            try {
                setIsResolving(true);
                await getMerchantTransactionReference(sessionId, (response) => {
                    if (response.succeeded === true) {
                        setMerchantTransactionReference(response.response.merchant_reference);
                    }
                }, () => {});
            } catch (err) {
            } finally {
                setIsResolving(false);
            }
        };

        fetch();
    }, [sessionId, getMerchantTransactionReference]);

    return { merchantTransactionReference, isResolving };
};

export default useResolveTransactionReference;
